<script>

export default {
    name: "HomeAboutBlock",
}
</script>

<template>
    <div class="w-full bg-grayBg rounded-3xl text-black overflow-hidden">
        <div class="grid grid-cols-1 md:grid-cols-2 h-full md:min-h-[325px] divide-x">
            <div class="flex-1 flex flex-col order-2 md:order-1 p-5 md:p-10">
                <h1 class="mb-[30px] text-2xl font-bold ">
                    Металлопрокат-1 — надежный поставщик металлопродукции в России.
                </h1>
                <div class="flex flex-col gap-2 text-sm">
                    <p> Компания Металлопрокат-1 предлагает широкий ассортимент металлопроката с доставкой по всей
                        России. В наличии и под заказ: арматура, лист стальной, швеллер, уголок, двутавровая балка,
                        труба профильная и круглая, кладочная сетка, проволока и другие виды металлопродукции. Мы
                        работаем как с крупными строительными организациями, так и с частными клиентами.
                    </p>
                    <p> У нас вы можете купить металлопрокат оптом и в розницу по конкурентным ценам. Поставки
                        осуществляются напрямую от заводов-производителей, что позволяет поддерживать низкие цены и
                        широкий ассортимент. В наличии как черный, так и цветной металлопрокат, горячекатаный и
                        холоднокатаный прокат, оцинкованные листы, трубы электросварные и бесшовные.
                    </p>
                    <p> Предоставляем услуги резки, гибки и обработки металла по индивидуальным размерам. Все заказы
                        комплектуются на собственных складах и доставляются точно в срок. Возможны самовывоз, поставка
                        по заявке, а также работа с НДС и без.
                    </p>
                </div>
            </div>
            <div class="order-1 md:order-2">
                <div class="w-full h-full grid grid-cols-3 divide-x divide-y">
                    <div class="flex items-center justify-center md:hover:bg-gray-200 transition">
                        <img src="@img/partners/1.webp" alt="Партнёр 1"
                             class="w-full p-2 max-h-[70px] md:max-h-[100px] object-contain"/>
                    </div>
                    <div class="flex items-center justify-center md:hover:bg-gray-200 transition">
                        <img src="@img/partners/2.webp" alt="Партнёр 2"
                             class="w-full p-2 max-h-[70px] md:max-h-[100px] object-contain"/>
                    </div>
                    <div class="flex items-center justify-center md:hover:bg-gray-200 transition">
                        <img src="@img/partners/3.webp" alt="Партнёр 3"
                             class="w-full p-2 max-h-[70px] md:max-h-[100px] object-contain"/>
                    </div>
                    <div class="flex items-center justify-center md:hover:bg-gray-200 transition">
                        <img src="@img/partners/4.webp" alt="Партнёр 4"
                             class="w-full p-2 max-h-[70px] md:max-h-[100px] object-contain"/>
                    </div>
                    <div class="flex items-center justify-center md:hover:bg-gray-200 transition">
                        <img src="@img/partners/5.webp" alt="Партнёр 5"
                             class="w-full p-2 max-h-[70px] md:max-h-[100px] object-contain"/>
                    </div>
                    <div class="flex items-center justify-center md:hover:bg-gray-200 transition">
                        <img src="@img/partners/6.webp" alt="Партнёр 6"
                             class="w-full p-2 max-h-[70px] md:max-h-[100px] object-contain"/>
                    </div>
                    <div class="flex items-center justify-center md:hover:bg-gray-200 transition">
                        <img src="@img/partners/7.webp" alt="Партнёр 7"
                             class="w-full p-2 max-h-[70px] md:max-h-[100px] object-contain"/>
                    </div>
                    <div class="flex items-center justify-center md:hover:bg-gray-200 transition">
                        <img src="@img/partners/8.webp" alt="Партнёр 8"
                             class="w-full p-2 max-h-[70px] md:max-h-[100px] object-contain"/>
                    </div>
                    <div class="flex items-center justify-center md:hover:bg-gray-200 transition">
                        <img src="@img/partners/zavod_nlmk.webp" alt="Партнёр 9"
                             class="w-full p-2 max-h-[70px] md:max-h-[100px] object-contain"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
